
import { getPercentage } from "@/helpers";
import { defineComponent, computed } from "vue";

export default defineComponent({
  name: "CategoryBreakdown",
  props: {
    score: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    max: {
      type: Number,
      required: true,
    },
    min: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const computedScore = computed(() => {
      return getPercentage(props.score, props.min, props.max);
    });

    return {
      computedScore,
    };
  },
});
